import { render, staticRenderFns } from "./data.vue?vue&type=template&id=02743adf&scoped=true&"
import script from "./data.vue?vue&type=script&lang=js&"
export * from "./data.vue?vue&type=script&lang=js&"
import style0 from "./data.vue?vue&type=style&index=0&id=02743adf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02743adf",
  null
  
)

export default component.exports